import React, {useCallback, useContext, useEffect, useState} from "react";

import EditProfile from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/DeleteRed.svg";
import {empType, Operation, PageFor} from "../../../../../utils/Enum.types";
import {Label} from "../../../../../stories/Label/Label";
import TiptapEditor from "../../../../../styles/TipTapEditor";
import {CustomModal} from "../../../../../utils/UtilFunctions";
import {
  ViewAssetStylesRaiseTicket,
  ViewMoreFileStyles,
} from "../../../../../styles/CustomModalStyles";
import Edit from "./Edit";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import {useLazyQuery, useMutation} from "@apollo/client";
import {
  DeletePmuCommentsResult,
  DeletePmuCommentsVars,
  GetMomDetailsResult,
  GetMomDetailsVars,
  GetVendorNotesResult,
  GetVendorNotesVars,
  VendorNotes,
} from "../queries/types";
import {GetMomDetails, GetVendorNotes} from "../queries/query";
import {Editor} from "@tiptap/core";
import {
  EMPTY_STRING,
  emptyIdAndModal,
  emptyMessage,
} from "../../../../../utils/constants";
import {idAndFlagType} from "../../../../../utils/formTypes";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import {DeletePmuComments} from "../queries/mutations";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import {msgType} from "../../../../../utils/types";
import Pdf from "../../../../../images/DownloadPdf.svg";
import Image from "../../../../../images/DownloadImage.svg";
import Doc from "../../../../../images/WordDocument.svg";
import Xls from "../../../../../images/Excel.svg";

import MessageModal from "../../../../../customComponents/MessageModal";
import {getDownloadUrl} from "../../../../../utils/DownloadFile";
import {AppContext} from "../../../../../context/context";
import ViewNotes from "../view/ViewNotes";
import MeetingDetailsLeft, {docTypeEnum} from "../view/PreviousMeetingDetails";
import PreviousMeetingDetails from "../view/PreviousMeetingDetails";
import {Title} from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import {Button} from "../../../../../stories/Button/Button";
export interface stateType {
  setComment: React.Dispatch<React.SetStateAction<string>>;
  comment: string;
}

export interface fileStateType {
  setSelectedFiles: React.Dispatch<React.SetStateAction<File[]>>;
  selectedFiles: File[];
}

export interface Props {
  commentState: stateType;
  filesState: fileStateType;
  editor: Editor | null;
}

const Plan = ({commentState, editor, filesState}: Props) => {
  const [editList, setEditList] = useState<idAndFlagType>(emptyIdAndModal);
  const {state} = useContext(AppContext);
  const [deleteId, setDeleteId] = useState(0);
  const [deleteModal, setDeleteModal] = useState(false);
  const [attachmentId, setAttachmentId] = useState(0);
  const [pmuFilesModal, setPmuFilesModal] = useState(false);

  const [commentFiles, setPmuFiles] = useState<string[]>([]);
  const [message, setMessage] = useState<msgType>(emptyMessage);

  const [vendorNotes, setVendorNotes] = useState<VendorNotes[]>([]);

  const [commentOrResponse, setCommentOrResponse] = useState<
    docTypeEnum.COMMENT | docTypeEnum.PMU_RESPONSE
  >(docTypeEnum.COMMENT);

  const {selectedFiles, setSelectedFiles} = filesState;

  const {user_details} = useLoggedInUserDetails();

  const {customer_id, momID, projectID} = useUrlParams();
  const [GetDetails, {data: projectData}] = useLazyQuery<
    GetMomDetailsResult,
    GetMomDetailsVars
  >(GetMomDetails);

  const [GetNotes, {data: notesData}] = useLazyQuery<
    GetVendorNotesResult,
    GetVendorNotesVars
  >(GetVendorNotes);

  const [DeleteComment] = useMutation<
    DeletePmuCommentsResult,
    DeletePmuCommentsVars
  >(DeletePmuComments, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  useEffect(() => {
    if (customer_id && momID && projectID) {
      GetDetails({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest: true,
        },
      });
    }
  }, [GetDetails, momID, projectID, customer_id]);

  useEffect(() => {
    if (
      customer_id &&
      momID &&
      projectID &&
      state.empSubType === empType.VENDOR_MANAGER
    ) {
      GetNotes({
        variables: {
          customerID: customer_id,
          momID,
          projectID,
          latest: true,
        },
      }).then(({data}) => {
        if (data && data.GetVendorNotes.length) {
          setVendorNotes(data.GetVendorNotes);
        } else {
          setVendorNotes([]);
        }
      });
    }
  }, [GetNotes, momID, projectID, customer_id, state.empSubType, notesData]);

  const handleDelete = (id: number) => {
    setDeleteModal(false);
    DeleteComment({
      variables: {
        customerID: customer_id!,
        momDetailsID: id,
        user_details,
      },
      refetchQueries: [
        {
          query: GetMomDetails,
          variables: {
            customerID: customer_id,
            momID,
            projectID,
            latest: true,
          },
        },
      ],
    }).then(({data}) => {
      if (data && data.DeletePmuComments) {
        setMessage({
          flag: true,
          message: "Comment deleted successfully",
          operation: Operation.DELETE,
        });
      }
    });
  };

  const downloadFile = (ext: string, index: number, commentId: number) => {
    const filename = `${customer_id}/momDetails/${momID}/${projectID}/${commentId}_${index}.${ext}`;
    getDownloadUrl(filename, true);
  };

  const chooseFile = useCallback(
    (file: string, index: number, commentId: number) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({image}: {image: string}) => {
        return (
          <div
            className="meeting-details--left--block--attachments--file"
            onClick={() => downloadFile(ext!, index, commentId)}
          >
            <span>{file}</span> <img src={image} alt="not found" />
          </div>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={Image} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    [selectedFiles]
  );

  const chooseFileMore = useCallback(
    (file: string, index: number, commentId: number) => {
      const ext = file.split(".").pop();

      const ReturnComp = ({image}: {image: string}) => {
        return (
          <>
            <div
              className="meeting-details--left--block--attachments--file"
              onClick={() => downloadFile(ext!, index, commentId)}
            >
              <span> {file}</span> <img src={image} alt="not found" />
            </div>
          </>
        );
      };
      switch (ext) {
        case "jpg":
        case "jpeg":
        case "png":
          return <ReturnComp image={Image} />;
        case "doc":
        case "docx":
          return <ReturnComp image={Doc} />;
        case "xlsx":
        case "xls":
        case "csv":
          return <ReturnComp image={Xls} />;
        case "pdf":
          return <ReturnComp image={Pdf} />;
        default:
          return <></>;
      }
    },
    []
  );

  return (
    <div className="plan-meeting">
      {state.empSubType === empType.VENDOR_MANAGER ? (
        vendorNotes.length ? (
          <div className="plan-meeting--left">
            <ViewNotes vendorNotes={vendorNotes} />
          </div>
        ) : null
      ) : (
        <>
          <div className="plan-meeting--left" style={{width: "50%"}}>
            <div className="plan-meeting__header">
              Discussed points in Minutes of Meeting
            </div>
            <div className="plan-meeting__block">
              {projectData ? (
                projectData.GetMomDetails.map((res, index) => {
                  let pmuFiles: string[] = [];
                  let pmuVisibleFiles: string[] = [];
                  let pmuRemainingCount = 0;

                  if (res.pmuComments.trim() !== EMPTY_STRING) {
                    pmuFiles = res.pmuDocuments.split(";");
                    pmuVisibleFiles = pmuFiles.slice(0, 2);
                    pmuRemainingCount = pmuFiles.length - 2;
                  }
                  return (
                    <div key={index} className="plan-meeting__block--li">
                      <span> {index + 1}.</span>
                      <div className="meeting-details--left--block--attachments">
                        <span
                          dangerouslySetInnerHTML={{__html: res.pmuComments}}
                        />
                        {/* <span>
                        {res.pmuDocuments.split(";").map((file, index) => {
                          const filename = file.split("/").pop();
                          return chooseFile(filename!, index, res.id);
                        })}
                      </span> */}

                        <div className="meeting-details--left--block--attachments--flex">
                          {pmuVisibleFiles.map((file, i) => {
                            const filename = file.split("/").pop();
                            return (
                              <div key={i}>
                                {chooseFile(filename!, i, res.id)}
                              </div>
                            );
                          })}

                          {pmuRemainingCount > 0 && (
                            <button
                              onClick={() => {
                                setAttachmentId(res.id);
                                setPmuFiles(res.pmuDocuments.split(";"));
                                setPmuFilesModal(!pmuFilesModal);
                              }}
                            >
                              +{pmuRemainingCount} more
                            </button>
                          )}
                        </div>

                        <CustomModal
                          style={ViewMoreFileStyles}
                          isOpen={pmuFilesModal}
                          onRequestClose={() => setPmuFilesModal(false)}
                          contentComponent={
                            <div className="meeting-details--left--block--more-files">
                              <div className="meeting-details--left--block--more-files-t">
                                <Title>Uploaded Files</Title>
                                <img
                                  src={Close}
                                  alt=""
                                  onClick={() =>
                                    setPmuFilesModal(!pmuFilesModal)
                                  }
                                />
                              </div>
                              <div className="meeting-details--left--block--more-files--block">
                                <ul>
                                  {commentFiles.map((files, index) => {
                                    const filename = files.split("/").pop();

                                    return (
                                      <li key={index}>
                                        {chooseFileMore(
                                          filename!,
                                          index,
                                          attachmentId
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                              <Button
                                mode="cancel"
                                onClick={() => setPmuFilesModal(!pmuFilesModal)}
                              />
                            </div>
                          }
                        />
                      </div>
                      <button
                        onClick={() => {
                          setCommentOrResponse(docTypeEnum.PMU_RESPONSE);
                          setEditList({
                            flag: true,
                            id: res.id,
                          });
                        }}
                        className="meeting-details--left--block--update"
                      >
                        {res.pmuResponse ? "Edit Pmu Response" : "Pmu Response"}
                      </button>
                      <img
                        src={EditProfile}
                        alt=""
                        onClick={() => {
                          setCommentOrResponse(docTypeEnum.COMMENT);
                          setEditList({
                            flag: true,
                            id: res.id,
                          });
                        }}
                      />
                      <img
                        src={Delete}
                        alt=""
                        onClick={() => {
                          setDeleteId(res.id);
                          setDeleteModal(!deleteModal);
                        }}
                      />
                    </div>
                  );
                })
              ) : (
                <></>
              )}
            </div>
            <div className="plan-meeting__text-area pb-4">
              <Label>Description</Label>
              <TiptapEditor
                commentState={commentState}
                editor={editor}
                filesState={{selectedFiles, setSelectedFiles}}
              />
            </div>
          </div>
        </>
      )}

      <div
        className={`plan-meeting--right${
          state.empSubType !== empType.VENDOR_MANAGER || vendorNotes.length
            ? ""
            : "--without-vn"
        }`}
      >
        <PreviousMeetingDetails
          pageType={
            window.location.pathname.includes("respond")
              ? PageFor.GENERAL
              : PageFor.VIEW
          }
          momID={momID!}
          latest={state.empSubType === empType.VENDOR_MANAGER ? true : false}
          setPresentDetails={setDeleteModal}
        />
      </div>

      <CustomModal
        style={ViewAssetStylesRaiseTicket}
        isOpen={editList.flag}
        onRequestClose={() => setEditList(emptyIdAndModal)}
        contentComponent={
          <Edit
            setModalFlag={setEditList}
            idModalFlag={editList}
            fieldType={commentOrResponse}
          />
        }
      />

      <DeleteModal
        id={deleteId}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={handleDelete}
      />

      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default Plan;
